import HoverTooltip from 'components/common/HoverTooltip';
import Price from 'components/common/Price';
import Service from 'models/ServiceModel';
import React from 'react';
import { FaRegQuestionCircle } from 'react-icons/fa';

const ServiceTotalBreakdown = ({ service }: { service: Service }) => {
    const renderTotalBreakdown = (service: Service) => {
        const row = (label: string, cents: number, opts?: { bold?: boolean }) => (
            <div className={`flex justify-between ${opts?.bold ? 'font-bold' : ''}`}>
                <span className="mr-6">{label}</span>
                <span>
                    <Price price={cents || 0} />
                </span>
            </div>
        );
        return (
            <div className="bg-white text-gray-700 text-sm p-3 rounded-lg shadow-lg border border-gray-200 w-52">
                {row('Labor', service.totalLaborCents)}
                {row('Parts', service.totalPartsCents)}
                {!!service.totalSubcontractsCents && row('Sublet', service.totalSubcontractsCents)}
                {row('Fees', service.totalFeeCents)}
                <div className="border-t border-gray-200 my-1.5" />
                {row('Subtotal', service.totalCents)}
                {row('Tax', service.totalTaxCents)}
                <div className="border-t border-gray-200 my-1.5" />
                {row('Total', service.grandTotalCents, { bold: true })}
            </div>
        );
    };
    return (
        <HoverTooltip content={renderTotalBreakdown(service)}>
            <FaRegQuestionCircle className="ml-1.5 text-gray-400 hover:text-gray-600 clickable" />
        </HoverTooltip>
    );
};

export default ServiceTotalBreakdown;
